import { DataGrid, GridColDef } from "@mui/x-data-grid";
import React from "react";
import { useNavigate } from "react-router";
import { Box } from '@mui/material';

interface DataRow {
    id: string;
    registrationNumber: string;
    make: string;
    model: string;
    vin: string;
}

interface DataGridChildProps {
    electricVehicles: DataRow[];
}

const ElectricVehicleTable: React.FC<DataGridChildProps> = ({ electricVehicles }) => {
    const navigate = useNavigate();

    const columns: GridColDef[] = [
        {
            field: "registrationNumber",
            headerName: "Registration Number",
            flex: 1,
            minWidth: 150,
        },
        {
            field: "vin",
            headerName: "VIN",
            flex: 1,
            minWidth: 180,
        },
        {
            field: "make",
            headerName: "Make",
            flex: 1,
            minWidth: 120,
        },
        {
            field: "model",
            headerName: "Model",
            flex: 1,
            minWidth: 120,
        },
    ];

    return (
        <Box sx={{ width: '100%', pt: 3, '& .MuiDataGrid-root': { border: 'none' } }}>
            <DataGrid
                rows={electricVehicles}
                columns={columns}
                autoHeight
                disableColumnMenu
                initialState={{
                    pagination: {
                        paginationModel: {
                            page: 0,
                            pageSize: 15
                        }
                    }
                }}
                pageSizeOptions={[15]}
                disableRowSelectionOnClick
                checkboxSelection
                sx={{
                    '& .MuiDataGrid-columnHeaders': {
                        backgroundColor: 'background.paper',
                        borderBottom: 1,
                        borderColor: 'divider',
                    },
                    '& .MuiDataGrid-cell': {
                        borderBottom: 1,
                        borderColor: 'divider',
                    },
                    '& .MuiDataGrid-row:hover': {
                        backgroundColor: 'action.hover',
                    },
                }}
            />
        </Box>
    );
}

export default ElectricVehicleTable;
